import React from 'react';
import { Modal } from './Modal';
import { getMoraleTier } from './MoraleBadge';
import { Morale } from '../../domain/entities';
import './MoraleBadge.css';
import './HelpModal.css';

const MORALE_LEVELS: Morale[] = ['Ecstatic', 'Happy', 'Content', 'Unhappy', 'Furious'];

interface MoraleInfoModalProps {
    isOpen: boolean;
    onClose: () => void;
    currentMorale?: Morale;
}

export const MoraleInfoModal: React.FC<MoraleInfoModalProps> = ({ isOpen, onClose, currentMorale }) => {
    const MORALE_TIERS = MORALE_LEVELS.map(morale => ({ morale, ...getMoraleTier(morale) }));

    return (
        <Modal isOpen={isOpen} onClose={onClose} className="help-modal">
            <h2>Morale Levels Explained</h2>
            <p>A player's morale affects their performance and contract negotiations. Unhappy players may ask to leave.</p>
            <ul style={{ listStyle: 'none', padding: 0, marginTop: '16px' }}>
                {MORALE_TIERS.map(tier => (
                    <li key={tier.label} className={`help-modal-row ${currentMorale === tier.morale ? 'highlight-row' : ''}`}>
                        <span className={`morale-badge ${tier.className}`} style={{ flexShrink: 0 }}>{tier.label}</span>
                        <span><strong>{tier.morale}:</strong> {tier.description}</span>
                    </li>
                ))}
            </ul>
            <div className="modal-actions">
                <button className="button" onClick={onClose}>Close</button>
            </div>
        </Modal>
    );
};
